module.exports = __webpack_public_path__ + "static/img/Planificaciones_7_taxonomía de bloom@4x.2b2c44dd.png";